import {
  type FirstDayOfWeek,
  type MonthType,
  type OnDatesChangeProps,
  useDatepicker,
} from "@datepicker-react/hooks";

import { getLang } from "@hopper-b2b/i18n";
import { Box } from "@material-ui/core";
import clsx from "clsx";
import { Month } from "../Month";
import "./styles.scss";
import { firstWeekDay } from "../../component";

export interface IGroupViewProps {
  minAllowedDate: Date | null;
  maxAllowedDate: Date | null;
  setFocusedMonthIndex?: (index: number) => void;
  numberOfMonths: number;
  priceRangeTags: JSX.Element;
  firstDayOfWeek?: FirstDayOfWeek;
}

// temporarily disable linting here to prevent errors due to the placeholder function
export const GroupView = ({
  minAllowedDate,
  maxAllowedDate,
  setFocusedMonthIndex,
  numberOfMonths,
  priceRangeTags,
  firstDayOfWeek: overrideFirstDayOfWeek,
}: IGroupViewProps) => {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const handleDateChange = (props: OnDatesChangeProps) => {}; // required by useDatepicker; month navigation is handled internally

  const { firstDayOfWeek, activeMonths } = useDatepicker({
    firstDayOfWeek: overrideFirstDayOfWeek ?? firstWeekDay(getLang()),
    startDate: minAllowedDate,
    endDate: maxAllowedDate,
    focusedInput: null,
    onDatesChange: handleDateChange,
    numberOfMonths,
  });

  return (
    <Box className={clsx("group-view-date-range-picker")}>
      <Box className="price-range-tags-section">{priceRangeTags}</Box>
      <Box className="months-container">
        {renderMonths(activeMonths, firstDayOfWeek, setFocusedMonthIndex)}
      </Box>
    </Box>
  );
};

const renderMonths = (
  months: MonthType[],
  firstDayOfWeek: FirstDayOfWeek,
  setFocusedMonthIndex?: (index: number) => void
) =>
  months.map((month: MonthType, index: number) => (
    <Month
      key={`${month.year}-${month.month}`}
      year={month.year}
      month={month.month}
      firstDayOfWeek={firstDayOfWeek}
      date={month.date}
      hideWeekdayLabels={true}
      rootClassName="group-view-month-root"
      headerClassName="group-view-month-label"
      bodyClassName="group-view-month-body"
      monthFormat="MMM"
      isMiniCalendar={true}
      onClick={() => setFocusedMonthIndex && setFocusedMonthIndex(index)}
    />
  ));
